
























import { defineComponent, reactive, SetupContext, toRef, toRefs, watch, onMounted } from "@vue/composition-api";
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";
import { Sheet } from "../../modules/teacher/SaitenResultUpload"

export interface Data {
  sheet_id: string
  sheet: Sheet
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "drop-area": DropArea,
  },
  setup(props, context: SetupContext) {

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      sheet_id: "",
      sheet: new Sheet({}),
      errors: [],
    });

    /******************************
     * methods
     ******************************/

    const download = async (): Promise<void> => {
      window.location.href = `/api/saiten_result_upload/download/${state.sheet.id}`;
    }

    /**
     * アップロード処理
     */
    const upload = async (file: File): Promise<void> => {

      state.errors = [];

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }

      const formData = new FormData();
      formData.append(`upload[file]`, file);

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/saiten_result_upload/upload/${state.sheet.id}`, formData).then(response => {
        alert(`アップロードが完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_id = context.root.$route.params.sheet_id;
      await http.get(`/api/saiten_result_upload?sheet_id=${state.sheet_id}`).then(response => {
        state.sheet = new Sheet(response.data.sheet);
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        context.root.$store.dispatch('goSheetList');
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      download,
      upload,
    };
  },
})
